import { useUserContext } from "../../Hooks/useUserContext";
import { LoadingWrapper } from "../../Shared/LoadingWrapper";
import React, { useState } from "react";
import {
	Card,
	CardHeader,
	CardContent,
	CardActions,
	Typography
} from "@material-ui/core";
import { GoogleLogin } from "@react-oauth/google";

export function Login(props) {
	const [isLoading, setIsLoading] = useState(false);
	const user = useUserContext(props.config);

	function handleGoogleSuccess(credentialResponse) {
		setIsLoading(true);
		// credentialResponse.credential contains the JWT token
		user.login(credentialResponse.credential, (isSuccess) => {
			setIsLoading(false);
			if (isSuccess) {
				props.history.push("/");
			}
		});
	}

	function handleGoogleError() {
		setIsLoading(false);
		console.error("Google login failed");
	}

	return (
		<React.Fragment>
			<LoadingWrapper isLoading={isLoading}>
				<Card>
					<CardHeader title="Login!" />
					<CardContent>
						<Typography variant="body1">
							Click the button below to login using your Google account.
						</Typography>
					</CardContent>
					<CardActions>
						<GoogleLogin
							onSuccess={handleGoogleSuccess}
							onError={handleGoogleError}
						/>
					</CardActions>
				</Card>
			</LoadingWrapper>
		</React.Fragment>
	);
}
